/** Apply segment edits onto a rendered timeline clone for live preview. */

import { reflowRenderedLayouts } from './layout';

const LAYOUT_POSITION_KEYS = new Set([
  'x', 'y', 'w', 'h', 'max_width', 'width_pct', 'height_pct', 'dynamic', 'stack_index',
]);

function mergeLayoutPreservingPositions(existing, patch) {
  if (!patch || typeof patch !== 'object') return existing;
  const out = { ...(existing || {}) };
  Object.entries(patch).forEach(([k, v]) => {
    if (!LAYOUT_POSITION_KEYS.has(k)) out[k] = v;
  });
  return out;
}

export function mergeSegmentsIntoRendered(rendered, segments) {
  if (!rendered) return null;
  const merged = JSON.parse(JSON.stringify(rendered));
  const blockPatch = {};
  (segments || []).forEach((seg) => {
    (seg.blocks || []).forEach((b) => {
      if (!b.block_id) return;
      blockPatch[b.block_id] = {
        content: b.screen_text,
        narration: b.narration,
        layout: b.layout,
        image_url: b.image_url,
        type: b.type,
        list_level: b.list_level,
        // Timing always comes from rendered_timeline (post TTS sync), not stale segment fields.
      };
    });
  });

  merged.elements = (merged.elements || []).map((el) => {
    const p = blockPatch[el.id];
    if (!p) return el;
    const out = {
      ...el,
      content: p.content !== undefined ? p.content : el.content,
      narration: p.narration !== undefined ? p.narration : el.narration,
      layout: p.layout ? mergeLayoutPreservingPositions(el.layout, p.layout) : el.layout,
      image_url: p.image_url || el.image_url,
      type: p.type || el.type,
      list_level: p.list_level != null ? p.list_level : el.list_level,
    };
    // Keep narration_start/end/start/end from rendered (aligned to audio track).
    return out;
  });

  const scenes = [...(merged.scenes || [])];
  (segments || []).forEach((seg, i) => {
    if (i < scenes.length && seg.code_panel_layout) {
      scenes[i] = { ...scenes[i], code_panel_layout: { ...seg.code_panel_layout } };
    }
  });
  merged.scenes = scenes;
  return reflowRenderedLayouts(merged);
}
